<div class="container">
  <div class="section-left">
    <form [formGroup]="newPasswordForm" (ngSubmit)="submitNewPassword()">
      <div class="logo">
        <img src="assets/images/logo.png" alt="logo" />
      </div>
      <h1>HERO</h1>
      <p i18n="@@auth.setNewPasswordText">
        Set your <strong>new password</strong>
      </p>

      <app-input
        leftIcon="ri-lock-fill"
        placeholder="Password"
        i18n-placeholder="@@auth.passwordPlaceholder"
        formControlName="password"
        type="password"
      />

      <app-password-requirements [password]="password" />

      <app-input
        leftIcon="ri-lock-fill"
        placeholder="Confirm Password"
        i18n-placeholder="@@auth.confirmPasswordPlaceholder"
        formControlName="confirmPassword"
        type="password"
      />

      <button
        pButton
        type="submit"
        class="p-button-block"
        label="Update Password"
        i18n-label="@@auth.updatePasswordButton"
        [disabled]="newPasswordForm.invalid"
      ></button>
    </form>
  </div>

  <div class="section-right"></div>

  <p-toast
    position="bottom-center"
    [showTransformOptions]="'translateY(100%) scale(1)'"
    [showTransitionOptions]="'0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55)'"
  />
</div>